import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { escapeRegExp } from "../regexp";
export var Replacer = /*#__PURE__*/ function() {
    "use strict";
    function Replacer(map) {
        _class_call_check(this, Replacer);
        _define_property(this, "regexp", void 0);
        _define_property(this, "map", void 0);
        this.map = map;
    }
    _create_class(Replacer, [
        {
            key: "build",
            value: function build() {
                if (this.regexp) {
                    return;
                }
                var groups = Object.keys(this.map).map(escapeRegExp).sort(function(a, b) {
                    return b.length - a.length;
                });
                var pattern = "(?:".concat(groups.join("|"), ")");
                this.regexp = new RegExp(pattern, "g");
            }
        },
        {
            key: "replace",
            value: function replace(string) {
                var _this = this;
                if (!string) {
                    return "";
                }
                this.build();
                return string.replace(this.regexp, function(substring) {
                    return _this.map[substring];
                });
            }
        }
    ]);
    return Replacer;
}();

//# sourceMappingURL=replacer.js.map